import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";
import { useEffect } from "react";
import { cache } from "../../utils";

export default function SignIn() {
  useEffect(() => {
    cache.del("USER");
    cache.del("TOKEN");
    cache.del("APP_IS_ACTIVE")
  }, []);
  return (
    <>
      <PageMeta
        title="SignIn"
        description="SignIn to your account"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
